import React from 'react';

export default class DefaultLayout extends React.Component {
  render() {
    const { body, title } = this.props.post;
    return (
      <div className="markdown">
        <h1>{title}</h1>
        <div dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ../wrappers/layouts/DefaultLayout.jsx
 **/